<div
  class="dashboard-tiim-study-participant"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
  fxLayoutGap="40px"
>
  <mat-tab-group
    mat-stretch-tabs
    dynamicHeight
    fxLayout="column"
    fxLayoutAlign="center"
    fxFill
    (selectedTabChange)="onParticipantTabChange($event)"
  >
    <mat-tab [label]="TIIM_STUDY_PARTICIPANT_PAGE_TABS.PARTICIPANT_DETAILS | uppercase"></mat-tab>
    <mat-tab [label]="TIIM_STUDY_PARTICIPANT_PAGE_TABS.SCREENING | uppercase"></mat-tab>
    <mat-tab [label]="TIIM_STUDY_PARTICIPANT_PAGE_TABS.SEND_NOTIFICATION | uppercase"></mat-tab>
  </mat-tab-group>

  <div class="dashboard-tiim-study-participant__tab-content" fxLayout="column" fxLayoutGap="30px">
    <div class="dashboard-tiim-study-participant__header" fxLayout="row" fxLayoutAlign="start center">
      <button mat-icon-button color="primary" aria-label="Back to Participants" (click)="backToParticipants()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="dashboard-tiim-study-participant__header-title">
        {{ selectedParticipant?.firstname + ' ' + selectedParticipant?.lastname }}
      </div>
    </div>
    <div
      *ngIf="tab === TIIM_STUDY_PARTICIPANT_PAGE_TABS.PARTICIPANT_DETAILS"
      fxLayout="column"
      fxLayoutGap="50px"
      fxLayoutAlign="center"
    >
      <form
        [formGroup]="optionsForm"
        class="dashboard-tiim-study-participant__options"
        fxLayout="column"
        fxLayoutAlign="space-between stretch"
        fxLayoutGap="15px"
      >
        <div fxLayout="row" fxLayoutAlign="space-between start">
          <div fxFlex="50" fxLayout="column" fxLayoutAlign="center stretch">
            <mat-radio-group
              class="dashboard-tiim-study-participant__options-list"
              fxLayout="column"
              fxLayoutAlign="space-between start"
              formControlName="chosenOption"
              [disabled]="!privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.PARTICIPANTS, PRIVILEGE_ACTIONS.ALL)"
            >
              <mat-radio-button
                [value]="TIIM_STUDY_PARTICIPANT_OPTIONS.NO_ACTION"
                aria-label="Select an option"
                class="dashboard-tiim-study-participant__options-list-option"
              >
                No Action
              </mat-radio-button>
              <mat-radio-button
                [disabled]="!!selectedTiimStudyParticipant.unsubscribed === true"
                [value]="TIIM_STUDY_PARTICIPANT_OPTIONS.REJECT"
                aria-label="Select an option"
                class="dashboard-tiim-study-participant__options-list-option"
              >
                Reject Participant
              </mat-radio-button>
              <mat-radio-button
                [disabled]="!!selectedTiimStudyParticipant.unsubscribed === true"
                *ngFor="let intervention of interventions"
                [value]="intervention.id"
                aria-label="Select an option"
                class="dashboard-tiim-study-participant__options-list-option"
              >
                Assign to {{ intervention.name }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <div
            fxFlex="50"
            fxLayout="column"
            fxLayoutAlign="center stretch"
            *ngIf="
              chosenOption.value &&
              chosenOption.value !== TIIM_STUDY_PARTICIPANT_OPTIONS.NO_ACTION &&
              chosenOption.value !== TIIM_STUDY_PARTICIPANT_OPTIONS.REJECT
            "
          >
            <mat-radio-group
              class="dashboard-tiim-study-participant__options-list"
              fxLayout="column"
              fxLayoutAlign="space-between start"
              formControlName="chosenStart"
              [disabled]="!privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.PARTICIPANTS, PRIVILEGE_ACTIONS.ALL)"
            >
              <mat-radio-button
                [value]="TIIM_STUDY_PARTICIPANT_START.INTERVENTION_STARTS"
                aria-label="Select an option"
                class="dashboard-tiim-study-participant__options-list-option"
              >
                Let this participant start when intervention starts
              </mat-radio-button>
              <mat-radio-button
                [value]="TIIM_STUDY_PARTICIPANT_START.CUSTOM_DATE"
                aria-label="Select an option"
                class="dashboard-tiim-study-participant__options-list-option"
              >
                Let this participant start on a custom date
              </mat-radio-button>
              <mat-form-field *ngIf="chosenStart.value === TIIM_STUDY_PARTICIPANT_START.CUSTOM_DATE">
                <input
                  matInput
                  [ngxMatDatetimePicker]="customDatePicker"
                  [min]="now"
                  formControlName="customDate"
                  [disabled]="!privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.PARTICIPANTS, PRIVILEGE_ACTIONS.ALL)"
                />
                <mat-datepicker-toggle matSuffix [for]="customDatePicker"></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #customDatePicker [showSeconds]="false" [stepHour]="1" [stepMinute]="1">
                </ngx-mat-datetime-picker>
                <mat-error *ngIf="customDate.hasError('required')">
                  Custom date is <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </mat-radio-group>
          </div>
          <div
            fxFlex="50"
            fxLayout="column"
            fxLayoutAlign="center stretch"
            *ngIf="chosenOption.value && chosenOption.value === TIIM_STUDY_PARTICIPANT_OPTIONS.REJECT"
          >
            <label class="dashboard-tiim-study-participant__label">E-mail notification</label>
            <div fxLayout="row">
              Participant is notified at
              {{ selectedTiimStudyParticipant.notifiedAt }}
            </div>
          </div>
        </div>
        <div fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="30px">
          <button
            mat-raised-button
            color="primary"
            fxFlexOffset="30px"
            fxFlexAlign="end"
            type="submit"
            (click)="saveParticipantOptions()"
            [disabled]="
              chosenOption.value === oldOption && chosenStart.value === oldStart && customDate.value === oldCustomDate
            "
          >
            {{ 'SAVE' | uppercase }}
          </button>
        </div>
      </form>
    </div>
    <div
      *ngIf="tab === TIIM_STUDY_PARTICIPANT_PAGE_TABS.SCREENING"
      fxLayout="column"
      fxLayoutGap="50px"
      fxLayoutAlign="center"
    >
      <dashboard-metrics-preview [selectedStudy]="selectedStudy"
                                 [showTimings]="false"
      ></dashboard-metrics-preview>
    </div>
    <div
      *ngIf="tab === TIIM_STUDY_PARTICIPANT_PAGE_TABS.SEND_NOTIFICATION"
      fxLayout="column"
      fxLayoutGap="50px"
      fxLayoutAlign="center"
    >
      <div
        *ngIf="
          !selectedTiimStudyParticipant.participant.pushEnabled ||
          !selectedTiimStudyParticipant.participant.device ||
          !selectedTiimStudyParticipant.participant.pushId
        "
      >
        It is not possible to send a push notification because this participant hasn't logged in on a mobile device yet.
      </div>
      <div
        *ngIf="
          selectedTiimStudyParticipant.participant.pushEnabled &&
          selectedTiimStudyParticipant.participant.device &&
          selectedTiimStudyParticipant.participant.pushId
        "
      >
        <form
          [formGroup]="notificationForm"
          class="dashboard-tiim-study-participant__notification"
          fxLayout="column"
          fxLayoutAlign="space-between stretch"
          fxLayoutGap="15px"
        >
          <div fxLayoutGap="25px">
            <mat-form-field fxFlex="100">
              <input matInput formControlName="message" placeholder="Message" />
              <mat-error *ngIf="message.hasError('required')"> Message is <strong>required</strong> </mat-error>
              <mat-error *ngIf="message.hasError('maxlength')">
                Message needs to have
                <strong>at most {{ message.errors?.maxlength.requiredLength }}</strong>
                characters
              </mat-error>
            </mat-form-field>
          </div>
          <div fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="30px">
            <button
              [disabled]="!!selectedTiimStudyParticipant.unsubscribed === true"
              mat-raised-button
              color="primary"
              fxFlexOffset="30px"
              fxFlexAlign="end"
              type="submit"
              (click)="sendNotification()"
            >
              {{ 'Send Notification' | uppercase }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
